import {clientsClaim as workbox_core_clientsClaim} from '/Users/theo/Documents/public_html/mateboer/wp-content/themes/pe-mateboer/library/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/Users/theo/Documents/public_html/mateboer/wp-content/themes/pe-mateboer/library/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "library/build/appimg/icons.bf62bbff.svg",
    "revision": "d1460e5ba16312c0dc3bfdd7097f13de"
  },
  {
    "url": "library/build/appmain.0c0fa3d4.css",
    "revision": null
  },
  {
    "url": "library/build/appmain.44e4ffd0.js",
    "revision": null
  },
  {
    "url": "library/build/appmain.44e4ffd0.js.LICENSE.txt",
    "revision": "e8c7d8d315f8a3fcee137773d2245be3"
  }
], {});








